import api from '@/app/api/axios.js';

export const useNotificationChannels = () => {
    const getNotificationChannels = async () => {
        const response = await api.get('/general/notifications/channels');

        return response.data;
    };

    const getNotificationChannelsSettings = async () => {
        const response = await api.get('/general/notifications/channels/settings');

        return response.data;
    };

    const updateNotificationChannelSettings = async (channel, configuration) => {
        const response = await api.patch('general/notifications/channels/settings', {
            channel,
            configuration,
        });

        return response.data;
    };

    return {
        getNotificationChannels,
        getNotificationChannelsSettings,
        updateNotificationChannelSettings,
    };
};
